import './App.css';
import VoteLookup from './containers/VoteLookup/VoteLookup';
import { Provider } from 'react-redux';
import {legacy_createStore as createStore , combineReducers, applyMiddleware, compose } from 'redux';
import reducer from './store/reducers/reducer';
import {thunk} from 'redux-thunk';
import { composeWithDevTools } from 'redux-devtools-extension';


function App() {
  

  const composeEnhancers = window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ || compose;

  //const store = createStore(reducer, composeWithDevTools(
    //applyMiddleware(thunk)));
  
  const store = createStore(reducer, applyMiddleware(thunk));
  
  return (
    <Provider store={store}>
      <div className="App">
        <VoteLookup></VoteLookup>
      </div>
    </Provider>
  );
}

export default App;
